import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const PublisherScheduleService = {
    listSchedules: async (page = 0, pageSize = 10, sort = "createdAt:desc", puzzleTypeFilter = "all") => {
        try {
            const params = { page, pageSize, sort };
            if (puzzleTypeFilter && puzzleTypeFilter !== "all") {
                params.puzzleType = puzzleTypeFilter;
            }
            const response = await ApiService.getData("/v1/publisher-schedule", params);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching publisher schedules:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch publisher schedules"
            };
        }
    },

    getSchedule: async (id) => {
        try {
            const response = await ApiService.getData(`/v1/publisher-schedule/${id}`);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching publisher schedule:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch publisher schedule"
            };
        }
    },

    createSchedule: async (scheduleData) => {
        try {
            const response = await ApiService.postData("/v1/publisher-schedule", scheduleData);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error creating publisher schedule:", error);
            return {
                success: false,
                error: error.message || "Failed to create publisher schedule"
            };
        }
    },

    updateSchedule: async (id, scheduleData) => {
        try {
            const response = await ApiService.putData(`/v1/publisher-schedule/${id}`, scheduleData);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error updating publisher schedule:", error);
            return {
                success: false,
                error: error.message || "Failed to update publisher schedule"
            };
        }
    },

    deleteSchedule: async (id) => {
        try {
            await ApiService.deleteData(`/v1/publisher-schedule/${id}`);
            return {
                success: true
            };
        } catch (error) {
            Logger.error("Error deleting publisher schedule:", error);
            return {
                success: false,
                error: error.message || "Failed to delete publisher schedule"
            };
        }
    },

    /**
     * @param {string|null|undefined} scheduleId
     * @param {number} page
     * @param {number} pageSize
     * @param {string} sort
     * @param {"all"|"success"|"failed"} [successFilter] — omit param when "all"
     * @param {string} [puzzleTypeFilter] — omit param when empty or "all"
     */
    listScheduleLogs: async (
        scheduleId,
        page = 0,
        pageSize = 10,
        sort = "createdAt:desc",
        successFilter = "all",
        puzzleTypeFilter = "all"
    ) => {
        try {
            const params = { page, pageSize, sort };
            if (scheduleId != null && scheduleId !== "") {
                params.scheduleId = scheduleId;
            }
            if (successFilter === "success") {
                params.success = true;
            } else if (successFilter === "failed") {
                params.success = "false";
            }
            if (puzzleTypeFilter && puzzleTypeFilter !== "all") {
                params.puzzleType = puzzleTypeFilter;
            }
            const response = await ApiService.getData("/v1/publisher-log/schedule", params);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching publisher logs:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch publisher logs"
            };
        }
    }
};

export default PublisherScheduleService;
